import { watchAddItemsToContainer } from './addItemsToContainer';
import { watchAddItemsToLoad } from './addItemsToLoad';
import { watchAddShipmentContainer } from './addShipmentContainer';
import { watchAdvanceLoadState } from './advanceLoadState';
import { watchCreateLoad } from './createLoad';
import { watchDeleteLoad } from './deleteLoad';
import { watchDeleteShipment } from './deleteShipment';
import { watchDeleteShipmentContainer } from './deleteShipmentContainer';
import { watchDeleteShipmentItem } from './deleteShipmentItem';
import { watchDeleteShipmentKit } from './deleteShipmentKit';
import { watchDeleteWarehouseGroup } from './deleteWarehouseGroup';
import { watchFetchCarrier } from './fetchCarrier';
import { watchFetchCarrierLoads } from './fetchCarrierLoads';
import { watchFetchCarriers } from './fetchCarriers';
import { watchFetchLoad } from './fetchLoad';
import { watchFetchLoadCalendar } from './fetchLoadCalendarItems';
import { watchFetchLoadEvents } from './fetchLoadEvents';
import { watchFetchLoadRoute } from './fetchLoadRoute';
import { watchFetchLogisticsDailySummaries } from './fetchLogisticsDailySummaries';
import { watchFetchShipment } from './fetchShipment';
import { watchFetchShipmentList } from './fetchShipmentList';
import { watchMoveShipmentItems } from './moveShipmentItems';
import { watchSplitShipmentItem } from './splitShipmentItem';
import { watchUpdateLoadDepartureDate } from './udpateDepartureDate';
import { watchUpdateLoad } from './updateLoad';
import { watchUpdateLoadFees } from './updateLoadFees';
import { watchUpdateLoadRoute } from './updateLoadRoute';
import { watchUpdateShipment } from './updateShipment';
import { watchUpdateShipmentContainer } from './updateShipmentContainer';
import { watchUpdateWarehouse } from './updateWarehouse';
import { watchUpdateWarehouseGroup } from './updateWarehouseGroup';

export const logisticsSagas = [
  watchAddItemsToContainer(),
  watchAddItemsToLoad(),
  watchAddShipmentContainer(),
  watchAdvanceLoadState(),
  watchCreateLoad(),
  watchDeleteLoad(),
  watchDeleteShipment(),
  watchDeleteShipmentContainer(),
  watchDeleteShipmentItem(),
  watchDeleteShipmentKit(),
  watchDeleteWarehouseGroup(),
  watchFetchCarrier(),
  watchFetchCarrierLoads(),
  watchFetchCarriers(),
  watchFetchLoad(),
  watchFetchLoadCalendar(),
  watchFetchLoadEvents(),
  watchFetchLoadRoute(),
  watchFetchLogisticsDailySummaries(),
  watchFetchShipment(),
  watchFetchShipmentList(),
  watchMoveShipmentItems(),
  watchSplitShipmentItem(),
  watchUpdateLoad(),
  watchUpdateLoadDepartureDate(),
  watchUpdateLoadFees(),
  watchUpdateLoadRoute(),
  watchUpdateShipment(),
  watchUpdateShipmentContainer(),
  watchUpdateWarehouse(),
  watchUpdateWarehouseGroup()
];
